import { PaletteTheme } from '@kite-js/theme-types';
import colors from '../colors';

type SemanticPalette = Pick<PaletteTheme, 'positive' | 'urgency' | 'alert' | 'neutral' | 'promo'>;

const semanticPalette: SemanticPalette = {
    positive: {
        darkSolid: {
            background: colors.green[500],
            text: colors.white,
        },
        solid: {
            background: colors.green[300],
            text: colors.white,
        },
        light: {
            background: colors.background[20],
            text: colors.text[800],
        },
        bordered: {
            background: colors.white,
            border: colors.green[300],
            text: colors.green[300],
        },
        plainText: {
            text: colors.text[500],
        },
        gradient: {
            backgroundStart: colors.green[300],
            backgroundEnd: colors.green[500],
            text: colors.white,
        },
    },
    urgency: {
        darkSolid: {
            background: colors.blue[400],
            text: colors.white,
        },
        solid: {
            background: colors.blue[300],
            text: colors.white,
        },
        light: {
            background: colors.blue[50],
            text: colors.blue[300],
        },
        bordered: {
            background: colors.white,
            border: colors.blue[300],
            text: colors.blue[300],
        },
        plainText: {
            text: colors.blue[300],
        },
        gradient: {
            backgroundStart: colors.blue[300],
            backgroundEnd: colors.blue[400],
            text: colors.white,
        },
    },
    alert: {
        darkSolid: {
            background: colors.red[500],
            text: colors.white,
        },
        solid: {
            background: colors.red[300],
            text: colors.white,
        },
        light: {
            background: colors.red[50],
            text: colors.red[500],
        },
        bordered: {
            background: colors.white,
            border: colors.red[100],
            text: colors.red[300],
        },
        plainText: {
            text: colors.red[300],
        },
    },
    neutral: {
        darkSolid: {
            background: colors.background[800],
            text: colors.white,
        },
        solid: {
            background: colors.background[200],
            text: colors.white,
        },
        light: {
            background: colors.blue[50],
            text: colors.blue[300],
        },
        bordered: {
            background: colors.white,
            border: colors.blue[300],
            text: colors.blue[300],
        },
        plainText: {
            text: colors.blue[300],
        },
    },
    promo: {
        darkSolid: {
            background: colors.background[150],
            text: colors.white,
        },
        solid: {
            background: colors.background[150],
            text: colors.white,
        },
        light: {
            background: colors.background[150],
            text: colors.white,
        },
        bordered: {
            background: colors.white,
            border: colors.background[150],
            text: colors.text[800],
        },
        plainText: {
            text: colors.text[800],
        },
    },
};

export default semanticPalette;
